import { useMemo } from "react";
//#region types
import { DateRange, FilterWithDateRange } from "models/formTypes/util";
import { TitleWithMonthRangeNavigatorProps } from "models/propTypes/commonPropTypes";
import { MonthPickerQuickSelection } from "models/propTypes/datepickerPropTypes";
//#endregion
//#region components
import { Grid, Divider } from "@mui/material";
import { MonthRangeNavigator, useFilterContext } from "components/common";
//#endregion
import { DateHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const TitleWithMonthRangeNavigator = <TFilter extends FilterWithDateRange>({
  title,
  monthPickerSelections,
  className,
  defaultStartDate,
  defaultEndDate,
}: TitleWithMonthRangeNavigatorProps) => {
  const { filter, setFilter } = useFilterContext<TFilter>();
  const today = DateHelper.today();

  const defaultDateRange: DateRange = useMemo(
    () => ({
      start: filter?.yearMonthRange?.start
        ? new Date(filter.yearMonthRange.start)
        : (defaultStartDate ?? DateHelper.getFirstDayOfMonth(today)),
      end: filter?.yearMonthRange?.end
        ? new Date(filter.yearMonthRange.end)
        : (defaultEndDate ?? DateHelper.getLastDayOfMonth(today)),
    }),
    [filter?.yearMonthRange, defaultStartDate, defaultEndDate, today]
  );

  const onDateRangeChange = (selection: MonthPickerQuickSelection) => {
    if (typeof selection.range !== "function") {
      setFilter({
        ...filter,
        yearMonthRange: selection.range,
      } as TFilter);
    }
  };

  return (
    <Grid container direction="row" className={className ?? cssExports.titleWithMonthRangeNavigator}>
      <Grid item className={cssExports.dashboardHeaderText}>
        {title}
      </Grid>
      <Grid item className={cssExports.titleDivider}>
        <Divider orientation="vertical" flexItem className={cssExports.verticalDividerGrey} />
      </Grid>
      <Grid item>
        <MonthRangeNavigator
          label=""
          range={defaultDateRange}
          onChange={onDateRangeChange}
          quickSelections={monthPickerSelections}
        />
      </Grid>
    </Grid>
  );
};

export default TitleWithMonthRangeNavigator;
